export default "__VITE_ASSET__c85c5ac1__"